import { useMutation } from '@tanstack/react-query';
import { ICoffeeLeadIssueView } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export const useCoffeeLeadIssueCompleteMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: any) => void;
	onSuccess?: (data: ICoffeeLeadIssueView, variables: string) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (issueId: string) => {
			return userSession.webServiceHelper.callAsync<ICoffeeLeadIssueView>(
				`coffeeleadissue/${issueId}/complete`,
				'POST'
			);
		},
		onError,
		onSuccess,
	});
};
